import React, { useRef, useState } from "react"

import moment from "moment-timezone"

import { Spinner } from "~tailwindui/Basics"

import classNames from "src/classNames"

import TimeProtectedModal from "./TimeProtectedModal"

type TimeProtectedMiroLinkProps = {
  email: string
  boardId: string
  startsAt: string
  buttonClassName?: string
  buttonText?: string
  tailwind?: boolean
  boardPending?: boolean
}

const TimeProtectedMiroLink: React.FC<
  TimeProtectedMiroLinkProps & React.HTMLProps<HTMLAnchorElement>
> = ({
  email,
  boardId,
  startsAt,
  buttonClassName = "btn solid green",
  buttonText = "Whiteboard",
  tailwind,
  boardPending = false,
}) => {
  const form = useRef<HTMLFormElement>()
  const [showModal, setShowModal] = useState(false)
  const [timeString, setTimeString] = useState("")

  const onClick = () => {
    const timeDiff = moment(startsAt).unix() - moment().unix()
    const timeDiffHours = timeDiff / 60 / 60

    if (timeDiffHours <= 1) {
      form.current.submit()
    } else {
      const hours = Math.floor(timeDiffHours)
      const minutes = Math.floor((timeDiffHours - hours) * 60)
      if (hours > 24) {
        const days = Math.floor(hours / 24)
        setTimeString(`${days} ${days === 1 ? "day" : "days"}`)
      } else {
        setTimeString(`${hours} hours and ${minutes} minutes`)
      }
      setShowModal(true)
    }
  }

  if (boardPending)
    return (
      <button
        disabled
        className={classNames(
          buttonClassName,
          "cursor-not-allowed bg-gray-400"
        )}
      >
        <div className="flex items-center justify-center gap-2">
          Board Pending
          <span className="inline-block">
            <Spinner className="!fill-white" />
          </span>
        </div>
      </button>
    )

  return (
    <>
      <form
        ref={form}
        method="POST"
        action="https://miro.com/sso/api/process-email"
        target="_blank"
      >
        <input name="email" type="hidden" value={email} />
        <input name="openBoardId" type="hidden" value={boardId} />
        <button type="button" onClick={onClick} className={buttonClassName}>
          {buttonText}
        </button>
      </form>
      <TimeProtectedModal
        isOpen={showModal}
        setOpen={setShowModal}
        timeString={timeString}
        tailwind={tailwind}
        onSubmit={() => form.current.submit()}
      />
    </>
  )
}

export default TimeProtectedMiroLink
